import React from 'react';

import Pagination from 'react-bootstrap/Pagination';


const numRange = (start, end) => {
  const output = [];
  for (let i = start; i < end; i++) {
    output.push(i);
  }
  return output;
}

const max = (x, y) => {
  if (x > y) {
    return x;
  } else {
    return y;
  }
}

const min = (x, y) => {
  if (x < y) {
    return x;
  } else {
    return y;
  }
}


const Paginator = (props) => {
  const { numPages, currentPage, loadPage } = props;

  const paginatorItem = (label, elemKey, pageNum) => (
    <Pagination.Item
        key={elemKey}
        onClick={(e) => loadPage(pageNum)}
        active={ currentPage === pageNum }
        disabled={ currentPage === pageNum } >
      {label}
    </Pagination.Item>
  );

  const leftBound = currentPage - 2;
  const clipLeft = leftBound < 0;
  const rightBound = currentPage + 3;
  const clipRight = rightBound >= numPages;

  const leftPageNums = numRange(max(0, leftBound), currentPage);
  const rightPageNums = numRange(currentPage + 1, min(rightBound, numPages));

  const ellipsis = (
    <Pagination.Item disabled={ true }>
      ...
    </Pagination.Item>
  );

  return (
    <Pagination className={"mt-2"} >
      { paginatorItem("First", "first", 0) }
      { ! clipLeft && ellipsis }
      { leftPageNums.map((i) => paginatorItem(i + 1, i, i)) }
      { paginatorItem(currentPage + 1, currentPage, currentPage)}
      { rightPageNums.map((i) => paginatorItem(i + 1, i, i)) }
      { ! clipRight && ellipsis }
      { paginatorItem("Last", "last", numPages - 1) }
    </Pagination>
  );
};

export default Paginator;
